import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

Vue.config.productionTip = false
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  VueRouter,
})


new Vue({
	router,// 挂载到 Vue 实例上的 VueRouter 实例
  render: h => h(App),
}).$mount('#app')
